import ImgixClient from '@imgix/js-core';

const client = new ImgixClient({
    domain: import.meta.env.VITE_IMGIX_URL,
    includeLibraryParam: false,
});

export default client;
